// Usage: This file is used to handle all the metadata related operations
// views/admin/organisations/metadata.blade.php
$(document).on('click', '.add-email-to-org-settings', function () {
    let input = $(this).closest('.input-group').find('input');
    let organisation = $(this).data('organisation');

    // set values
    let email = input.val();
    let name = input.attr('name');
    let route = '/admin/organisations/' + organisation + '/email-settings/';

    // find closes email-inputs-container
    let emailInputsContainer = input.parent().parent().next();

    //check if value is empty
    if (email === '') {
        // add red border to input
        input[0].style.border = '1px solid red';
        return;
    }

    // validate email
    if (!validateEmail(email)) {
        // add red border to input
        input[0].style.border = '1px solid red';
        return;
    }

    // send postInit request
    $.post(route, {key: name, value: email}, function (response) {
        // if success
        if (response.success) {
            // remove red border from input if exists
            input[0].style.border = 'none';

            // add another .saved-email-btn with value
            let html = '<div class="saved-email-btn pl-2 pr-1 mt-1 ml-1 rounded">' +
                '<div style="display: flex;">' +
                '<div style="flex: 1">' + email + '</div>' +
                '<div class="delete-saved-email-btn ml-2" style="flex: 1; font-weight: bolder;" ' +
                'data-organisation="' + organisation + '" data-value="' + email + '" data-key="' + name + '">x' +
                '</div>' +
                '</div>' +
                '</div>';

            emailInputsContainer.append(html);

            // remove value from input
            input.val('');
        } else {
            // add red border to input
            input[0].style.border = '1px solid red';
        }
    });
});

// if delete-saved-email-btn is clicked find the closest input and remove value
$(document).on('click', '.delete-saved-email-btn', function () {
    // get data values
    let organisation = $(this).data('organisation');
    let value = $(this).data('value');
    let key = $(this).data('key');

    let btnComponent = $(this).closest('.saved-email-btn');
    let route = '/admin/organisations/' + organisation + '/email-settings/destroy';

    // send delete request
    $.ajax({
        url: route,
        type: 'DELETE',
        data: {key: key, value: value},
        success: function (response) {
            if (response.success) {
                btnComponent.remove();
            }
        }
    });
});

/**
 *
 * @param email
 * @returns {boolean}
 */
window.validateEmail = (email) => {
    // regex for email
    let regex = /\S+@\S+\.\S+/;

    // return true if email is valid
    return regex.test(email);
}

$(document).on('change', '.update-label-templates select', function () {
    let select = $(this);
    let route = '/admin/organisations/' + select.data('organisation') + '/metadata/update-label-template';
    let key = select.attr('name');
    let value = select.val();

    // send postInit request
    $.post(route, {key: key, value: value}, function (response) {
        if (response.success) {
            // remove red border from input if exists
            select[0].style.border = 'none';

            // remove text-danger if exists
            select.parent().find('.text-danger').remove();
        } else {
            // add red border to input
            select[0].style.border = '1px solid red';

            // add text under select, to inform user that something went wrong
            let text = '<div class="text-danger"><a href="/admin/settings/label-templates">Add a (new) template here</a></div>';
            select.parent().append(text);
        }
    });
});

$(document).ready(function () {
    $('.update-label-templates select').trigger('change');
})
